import { apiMiddlewareActionTypes } from "../Middleware/apiMiddlewareActionTypes";
import { ApiAction, ApiActionInfo } from "./apiActions";

interface PostJson<TResult> {
    (creator: F<TResult>): F<ApiAction>;
    <A1>(creator: F1<A1, TResult>): F1<A1, ApiAction>;
    <A1, A2>(creator: F2<A1, A2, TResult>): F2<A1, A2, ApiAction>;
    <A1, A2, A3>(creator: F3<A1, A2, A3, TResult>): F3<A1, A2, A3, ApiAction>;
    <A1, A2, A3, A4>(creator: Fn<TResult>): Fn<TResult>;
}

export const postJson: PostJson<ApiActionInfo> =
    (creator: any) =>
    (...args: any[]) => ({
        type: apiMiddlewareActionTypes.API_CALL,
        ...creator(...args),
    });
